/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SxProps } from '@mui/material/styles';

const known: Record<string, boolean> = {
	New: true,
	Sale: true,
	Exclusive: true,
};

export const chipAdSX = (name: string): SxProps => ({
	boxShadow: '0px 1px 1px 1px rgba(0,0,0,0.15)',
	color: 'common.white',
	backgroundColor: 'primary.dark',
	fontWeight: 600,
	mr: 1,
	mb: 1,
	...(known[name] ? { background: '#c10c0d' } : {}),
	'> span.MuiChip-label': {
		pt: '2px',
	},
});

export const chipAdCustomSX = (identifier: string): SxProps => ({
	boxShadow: 'none',
	// color: 'common.white',
	backgroundColor: 'primary.dark',
	fontWeight: 'bold',
	textTransform: 'uppercase',
	fontSize: 'var(--font-size-micro)',
	letterSpacing: '0px',
	height: '20px',
	width: '70px',
	'@media(min-width:960px)': {
		width: '103px',
		fontSize: 'var(--font-size-small)',
		height: '24px',
	},
	borderRadius: '12px',
	mr: 0.5,
	mb: 0.5,
	...(identifier === 'DPT_SAPOferta' ? { background: '#AB2326', color: '#FFFFFF' } : {}),
	// '> span.MuiChip-label': {
	// 	pt: '2px',
	// },
	...(identifier === 'Preventa' ? { background: '#2C2C2C', color: '#FFFFFF' } : {}),
});
